import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import Marquee from "react-fast-marquee";
import Menu from "./Menu";
import Booking from "./Booking";
import Slider from "./Slider";
import Dataentry from "./Dataentry";
import SiteFooter from "./SiteFooter";
import axios from 'axios';
import Live from './Live';
import Popup from './Popup';
import Rightside from './Rightside';
import GalleryView from "./GalleryView";
import MainMenu from './MainMenu';

// const API_BASE = "http://localhost/myapp/api/uploads";

const API_BASE = "https://spst.in/myapp/api/uploads";

function Home() {

  const [uploads, setUploads] = useState([]);
  const [editId, setEditId] = useState(null);
  const [editName, setEditName] = useState('');

  useEffect(() => {
    fetchUploads();
  }, []);

  const fetchUploads = async () => {
    const res = await axios.get(`${API_BASE}/get.php`);
    setUploads(res.data);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this record?")) return;
    await axios.post(`${API_BASE}/delete.php`, { id });
    fetchUploads();
  };

  const startEdit = (item) => {
    setEditId(item.id);
    setEditName(item.name);
  };

  const saveEdit = async () => {
    await axios.post(`${API_BASE}/update.php`, { id: editId, name: editName });
    setEditId(null);
    fetchUploads();
  };



  return (
    <div>
        

      <MainMenu />
      

      
      <div className="row" style={{ background: 'maroon_', backgroundAttachment: 'fixed',margin:'50px'}}>

        <div className="col-md-4" style={{ padding: '35px' }}>
          <Rightside />
        </div>
        <div className="col-md-8" style={{ border: '1px solid silver', padding: '35px', borderRadius: '10px', boxShadow: '0px 0px 10px silver inset' }}>
          <GalleryView />
        </div>

      </div>

      <SiteFooter />






    </div>

  );
}

export default Home;